import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';
import { dismissToast, useToasts } from '../../lib/toast';

const ICON = { success: CheckCircle2, error: AlertCircle, info: Info } as const;
const TONE = { success: 'text-ok', error: 'text-danger', info: 'text-accent-ink' } as const;

export function Toaster() {
  const toasts = useToasts();
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-[min(380px,calc(100vw-32px))] flex-col gap-2" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => {
        const Icon = ICON[t.kind];
        return (
          <div key={t.id} role={t.kind === 'error' ? 'alert' : 'status'} className="pop pointer-events-auto flex items-start gap-2 px-3 py-2" data-testid="toast" data-kind={t.kind}>
            <Icon className={`mt-0.5 size-4 flex-none ${TONE[t.kind]}`} aria-hidden />
            <p className="min-w-0 flex-1 break-words text-[14px]">{t.message}</p>
            <button type="button" className="text-faint hover:text-ink" aria-label="Dismiss notification" onClick={() => dismissToast(t.id)}>
              <X className="size-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
